define.alias("shared/helpers/moment-format", "calendar/helpers/moment-format");